import { buildInstructionsUrl } from './instructionsUrl';
export const buildVortexRasterUrl = ({ width, format, bgColor, modelUrl, stageUrl, cimDocUrl }) => {
    const MAX_WIDTH = 2048;
    const baseUrl = `https://raster.vortex.documents.cimpress.io/v1/app/raster`;
    const params = new URLSearchParams();
    if (width) {
        params.append('width', Math.min(Math.ceil(width), MAX_WIDTH).toString());
    }
    if (format) {
        params.append('format', format);
    }
    if (bgColor) {
        params.append('bgColor', bgColor);
    }
    params.append('productConfigUrl', modelUrl);
    params.append('stageConfigUrl', stageUrl);
    params.append('renderingInstructionsUrl', buildInstructionsUrl({ cimDocUrl }));
    return `${baseUrl}?${params.toString()}`;
};
//# sourceMappingURL=vortexRasterUrl.js.map